import AWS from 'aws-sdk/global'
import GoogleAuth from 'vue-google-auth'

class AWSSuite {
  constructor (Vue, options) {
    const authOptions = {
      client_id: options.clientId
    }

    Object.defineProperty(authOptions, 'scope', {
      'get': () => 'profile email https://www.googleapis.com/auth/plus.login https://www.googleapis.com/auth/drive.readonly',
      'set': () => { }
    })

    Vue.use(GoogleAuth, authOptions)

    this._googleAuth = Vue.googleAuth()
    this._app = Vue
    this._options = options
    this._listeners = [(authenticated) => {
      Vue.$log.debug('Authentication changed to', authenticated)
    }]

    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: options.identityPoolId,
      Logins: { 'accounts.google.com': localStorage.getItem('$auth.token') }
    }, {
      region: 'us-east-1'
    })

    this._googleAuth.directAccess()

    this._googleAuth.load().then(() => {
      const auth = window.gapi.auth2.getAuthInstance()

      auth.then(() => {
        if (auth.isSignedIn.get()) {
          this._refresh()
        }

        auth.isSignedIn.listen((signedIn) => {
          if (!signedIn) {
            this.signOut()
          }
        })
      })
    })
  }

  signedIn () {
    this._app.$log.debug('Sign in check', localStorage.getItem('$auth.token') ? 'success' : 'fail')

    return localStorage.getItem('$auth.token')
  }

  signIn (callback) {
    if (this.signedIn()) {
      callback()
    } else {
      this._googleAuth.signIn((code) => {
        localStorage.setItem('$auth.token', code.getAuthResponse().id_token)
        this._refresh()
        callback()
      }, (error) => {
        callback(error)
      })
    }
  }

  onChange (callback) {
    this._listeners.push(callback)
  }

  signOut () {
    localStorage.removeItem('$auth.token')

    this._listeners.forEach((listener) => listener(false))
  }

  _refresh () {
    AWS.config.credentials.params.Logins['accounts.google.com'] = localStorage.getItem('$auth.token')

    AWS.config.credentials.get(() => {
      if (AWS.config.credentials.expired) {
        this.signOut()
      } else {
        this._listeners.forEach((listener) => listener(true))
      }
    })
  }
}

function plugin (Vue, options) {
  if (!plugin.installed) {
    plugin.installed = true

    let instance = null

    Object.defineProperties(Vue.prototype, {
      $auth: {
        get () {
          if (!instance) {
            instance = new AWSSuite(Vue, options)
          }

          return instance
        }
      }
    })
  }
}

export default plugin



// WEBPACK FOOTER //
// ./src/services/aws-suite.js